import type { FlowQuery } from '@twisto/api-graphql'
import { ANALYTICS_EVENTS, analytics, events } from '@twisto/utils'

type Step = NonNullable<FlowQuery['flow']>['currentStep']
export const logCloseButtonClick = (step?: Step) => {
  if (!step) {
    return
  }

  const stepName = step.__typename

  switch (stepName) {
    case 'PremiumAccountAgreementsStep': {
      analytics.logEvent(
        events[ANALYTICS_EVENTS.INSTALLMENTS_CONSENTS_CLOSE_BUTTON_CLICK]
      )

      return
    }
    case 'RiskApprovedStep': {
      analytics.logEvent(
        events[ANALYTICS_EVENTS.LIMIT_CONFIRMATION_CLOSE_BUTTON_CLICK]({
          revLimit: Number(step.paymentsLimit.value),
          instLimit: Number(step.installmentsLimit?.value),
        })
      )

      return
    }

    default:
      analytics.logEvent(
        events[ANALYTICS_EVENTS.EXIT_CONTINUE_BUTTON_CLICK]({ step: stepName })
      )
  }
}
